


































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { Mutations } from '@/ts/store/Constants';
import ProjectsData from '@/ts/ProjectsData';
import CorporationData from '@/ts/CorporationData';

@Component
export default class ProjectListItem extends Vue {
    @Prop() public projectData!: ProjectsData;

    constructor() {
        super();
    }
    get corporation(): CorporationData {
        if (!this.projectData) {
            return null;
        }

        return this.$store.getters['Corporations/getCorporation'](this.projectData.corporationId);
    }

    get projectOwner(): string {
        if (!this.corporation) {
            return '';
        }

        return this.corporation.name;
    }

    get projectImage() {
        let image = {};

        if (this.projectData.image) {
            image = { 'background-image': `linear-gradient(0deg, rgba(46, 103, 94, 0.38), rgba(46, 103, 94, 0.38)), url(${this.projectData.image.base64})` };
        }

        return image;
    }

    public selectItem(itemId: any) {
        this.$store.commit(Mutations.SELECT_PROJECT, itemId);
        this.$router.push({path: '/admin/unit-groups'});
    }

    public slideInForm(formKey: string, project: ProjectsData) {
        this.$store.commit(Mutations.SHOW_EDIT_PROJECT_FORM, formKey);
        this.$store.commit(Mutations.SET_PROJECT_TO_EDIT, project);
    }
}
